import script from "./ChatDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ChatDetailView.vue?vue&type=style&index=0&id=dccea280&lang=scss"

const __exports__ = script;

export default __exports__